var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dui-slim-progress-bar",class:[ _vm.vm.colorClass ]},[_c('span',{staticClass:"progress",style:({ 'width': _vm.value + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }